import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUserRoles } from "../redux/slices/userSlice";
import { mapUserRoles } from "./useRoleMapping";
import useTbdCheck from "./useTbdCheck";

function useFieldClass(formData, zone) {
  const userRoles = useSelector(selectUserRoles); // User roles

  const [roles, setRoles] = useState(mapUserRoles(userRoles));

  useEffect(() => {
    setRoles(mapUserRoles(userRoles));
  }, [userRoles]);

  useTbdCheck(formData, zone); // Track TBD status

  const isFieldTbd = (fieldValue) => {
    if (typeof fieldValue === "string") {
      fieldValue = fieldValue.trim().toLowerCase(); // Normalize to lowercase and remove extra whitespace
      return fieldValue.includes("tbd"); // Check if "tbd" is present anywhere in the string
    }
    return false;
  };

  const isFieldBlank = (fieldValue) => {
    if (fieldValue === null || fieldValue === undefined) {
      return true;
    }

    if (typeof fieldValue === "string") {
      return fieldValue.trim() === "";
    }

    return false;
  };

  const evaluateFieldClasses = (data) => {
    return Object.keys(data).reduce((acc, key) => {
      const value = data[key];
      if (isFieldTbd(value)) {
        acc[key] = "tbd-highlight"; // Highlight for TBD fields
      } else if (isFieldBlank(value) && (roles.Admin || roles.Apps)) {
        acc[key] = "blank-highlight"; // Highlight for blank fields (only for apps and admin roles)
      } else {
        acc[key] = ""; // Default class
      }
      return acc;
    }, {});
  };

  const fieldClasses = {};
  if (typeof formData === "object" && !Array.isArray(formData)) {
    Object.keys(formData).forEach((key) => {
      if (typeof formData[key] === "object" && formData[key] !== null) {
        // Handle nested fields (e.g., FillSources.js)
        fieldClasses[key] = evaluateFieldClasses(formData[key]);
      } else {
        // Handle flat fields (e.g., LevelControls.js)
        fieldClasses[key] = evaluateFieldClasses({ [key]: formData[key] })[key];
      }
    });
  }

  return fieldClasses;
}

export default useFieldClass;
